import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import {
  canAccess,
  resolveSidebarPortal,
  type AccessAction,
  type StoredSidebarAccess,
} from '../constants/sidebar-access';

@Injectable({ providedIn: 'root' })
export class PermissionService {
  constructor(private authService: AuthService) {}

  can(featureId: string, action: AccessAction = 'view'): boolean {
    const user = this.authService.getUser();
    if (!user) {
      return false;
    }
    const portal = resolveSidebarPortal(user.role?.name || user.role, {
      isAdmin: user.isAdmin,
      isTeacher: user.isTeacher,
      isSupervisor: user.isSupervisor,
      isSystemUser: user.isSystemUser || user.username === 'config',
    });
    return canAccess(portal, user.sidebarAccess as StoredSidebarAccess, featureId, action);
  }

  canView(featureId: string): boolean {
    return this.can(featureId, 'view');
  }

  canAdd(featureId: string): boolean {
    return this.can(featureId, 'add');
  }

  canEdit(featureId: string): boolean {
    return this.can(featureId, 'edit');
  }

  canDelete(featureId: string): boolean {
    return this.can(featureId, 'delete');
  }
}
